import { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import { useRouterHistory } from 'scbk-services/router';

interface PageContextInfo {
    id: string;
    path: string;
}
/**
 * 페이지 컨텍스트 Props
 */
interface PageContextProps {
    currentPageId: string;
    currentPage: PageContextInfo | undefined;
    perviousPageId: string;
    previousPage?: PageContextInfo | undefined;
}

const PageContext = createContext<PageContextProps | null>(null);

/**
 * 채널 컨텍스트 hook
 * @returns
 */
const usePageContext = () => {
    const context = useContext(PageContext);
    if (!context) throw new Error('usePageContext must be used within PageContextProvider');
    return context;
};

const PageContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const { currentRoute, previousRoute } = useRouterHistory((state) => ({
        currentRoute: state.currentRoute,
        previousRoute: state.previousRoute,
    }));

    /**
     *
     */
    const contextValue = useMemo((): PageContextProps => {
        return {
            currentPageId: currentRoute?.id ?? '',
            currentPage: currentRoute,
            perviousPageId: previousRoute?.id ?? '',
            previousPage: previousRoute,
        };
    }, [currentRoute, previousRoute]);

    return <PageContext.Provider value={contextValue}>{children}</PageContext.Provider>;
};

export { PageContextProvider, usePageContext };

export type { PageContextInfo };
